<template>
  <div class="compressed-content">
    <h3>Have you EVER been told that your blood sugar is elevated (above normal)?</h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.toldIsElevated">
      <b-form-radio v-model="survey.bloodSugar.toldIsElevated" name="yes" :value="true">Yes</b-form-radio>
      <b-form-radio v-model="survey.bloodSugar.toldIsElevated" name="no" :value="false">No</b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      toldIsElevated: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      toldIsElevated() { return this.survey.bloodSugar.toldIsElevated; }
    }
  };
</script>